import React from "react";
import styled from "@emotion/styled";
import { useNavigate, Link } from "react-router-dom";
import { green } from "@mui/material/colors";
import { clearRedirectAfterLogin } from "@auth/redirectAfterLogin";

import {
  Avatar,
  Badge,
  Divider,
  Tooltip,
  Menu,
  MenuItem,
  IconButton as MuiIconButton,
} from "@mui/material";
import { spacing } from "@mui/system";

import { useAuth } from "@auth/AuthContext";

const IconButton = styled(MuiIconButton)(spacing);

const AvatarBadge = styled(Badge)`
  margin-right: ${(props) => props.theme.spacing(1)};
  span {
    background-color: ${() => green[400]};
    border: 2px solid ${(props) => props.theme.palette.background.paper};
    height: 12px;
    width: 12px;
    border-radius: 50%;
  }
`;

const NavbarUserDropdown = React.memo(function NavbarUserDropdown() {
  const [anchorMenu, setAnchorMenu] = React.useState(null);
  const navigate = useNavigate();

  const { user, logout } = useAuth();

  const toggleMenu = (event) => {
    setAnchorMenu(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorMenu(null);
  };

  const handleSignOut = async (e) => {
    e.preventDefault();
    await logout();
    // Preserve phase/email if user was in password phase
    navigate("/login", {
      replace: true,
      state: {
        phase: "password",
        email: user?.email || "",
      },
    });
    // LWI-592 — AuthGuard re-renders when logout() clears state and
    // re-stashes the page the user was on. By the time `navigate` lands
    // them at /login the stash is the page they just signed out of. Drop
    // it here so signing back in returns to the dashboard, not the page
    // they explicitly logged out from.
    clearRedirectAfterLogin();
  };

  const handleChangeTenant = () => {
    closeMenu();
    navigate("/select-tenant", {
      state: { from: window.location.pathname },
    });
  };

  return (
    <React.Fragment>
      <Tooltip title="Account">
        <IconButton
          aria-owns={anchorMenu ? "menu-appbar" : undefined}
          aria-haspopup="true"
          onClick={toggleMenu}
          color="inherit"
          p={0}
          mx={1}
        >
          <AvatarBadge
            overlap="circular"
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            variant="dot"
          >
            {!!user && <Avatar alt={user.name} src={user.name} />}
          </AvatarBadge>
        </IconButton>
      </Tooltip>
      <Menu
        id="menu-appbar"
        anchorEl={anchorMenu}
        open={Boolean(anchorMenu)}
        onClose={closeMenu}
      >
        <MenuItem component={Link} to="/user/profile" onClick={closeMenu}>
          Profile
        </MenuItem>
        <MenuItem onClick={handleChangeTenant}>Change Tenant</MenuItem>
        <MenuItem onClick={closeMenu} disabled>
          Settings
        </MenuItem>
        <Divider />

        <MenuItem onClick={handleSignOut}>Sign out</MenuItem>
      </Menu>
    </React.Fragment>
  );
});

export default NavbarUserDropdown;
